var _rect, _circle, _path, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacementStaplesPortraitLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 116,
    viewBox: "0 0 87 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 116,
    rx: 3.86667,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.4666,
    cy: 58.0003,
    r: 27.0667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8542 70.5996H56.7006V55.6588C56.7006 51.9777 56.7006 43.966 45.6032 43.966C41.4891 43.966 37.4291 45.2111 34.56 48.1343L37.9704 51.5447C39.7027 49.9207 42.1928 48.838 44.8995 48.838C48.364 48.838 50.8542 50.5161 50.8542 53.71V54.4137H49.2302C42.7342 54.4137 32.8819 55.0092 32.8819 63.454C32.8819 68.5967 37.5374 71.2492 42.3552 71.2492C45.8198 71.2492 48.8512 69.95 50.6918 67.0268H50.8542V70.5996ZM50.4752 60.4225C50.4752 64.0495 48.364 66.3772 43.9251 66.3772C41.8139 66.3772 39.3779 65.3487 39.3779 62.9668C39.3779 59.2316 45.5491 58.9609 49.1219 58.9609H50.4752V60.4225Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.7998,
    y: 7.7334,
    width: 2.9,
    height: 15.4667,
    rx: 1.45,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.7998,
    y: 52.2002,
    width: 2.9,
    height: 15.4667,
    rx: 1.45,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.7998,
    y: 90.8662,
    width: 2.9,
    height: 15.4667,
    rx: 1.45,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacementStaplesPortraitLength);
export default __webpack_public_path__ + "static/media/placement-staples-portrait-length.8dbbab5e422ad0600e634c9d5be3c364.svg";
export { ForwardRef as ReactComponent };